import { useQuery } from '@tanstack/react-query'

import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { getSubscriptionPrices } from 'src/services/subscriptionApi'
import { SubscriptionPricesResponse } from 'src/services/subscriptionApi/interfaces/subscriptionApi.interface'

export const useGetSubscriptionPricesQuery = () => {
  return useQuery<SubscriptionPricesResponse>({
    queryFn: getSubscriptionPrices,
    queryKey: [QueryKey.GET_SUBSCRIPTION_PRICES],
  })
}
